import React from "react";
import DevicesTableBase from "./DevicesTableBase";

export default function DevicesTable({ devices = [] }) {
  return (
    <DevicesTableBase
      devices={devices}
      title="Devices"
      orderby="time_created"
      orderdirection="desc"
    />
  );
}
